import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "currentStep", "activeAccordionInput" ]

  update(event) {
    this.activeAccordionInputTarget.value = this.findActiveAccordionId();
  }

  makeChoice(event) {
    if(this.informIfStepIsLocked(event)) { return; }
    const buttonsContainer = event.target.closest('.binary-choice-buttons');
    const buttons = buttonsContainer.querySelectorAll('.button');
    buttons.forEach(b => b.classList.remove('selected'));
    event.target.classList.add('selected');
    this.submitForm();
  }

  findActiveAccordionElement() {
    const activeAccordionWrapper = Array.from(this.element.querySelectorAll('.accordion .accordion-wrapper')).find(el => el.classList.contains('active'));
    return Array.from(activeAccordionWrapper.children).find(el => el.tagName.toLowerCase() === 'div');
  }

  findActiveAccordionId() {
    const firstDirectDescendentDiv = this.findActiveAccordionElement();
    if(!firstDirectDescendentDiv) { return; }
    return firstDirectDescendentDiv.id;
  }

  nextStep(event) {
    this.currentStepTarget.value = event.target.dataset.currentStepName;
    this.submitForm();
  }

  allRequiredInputsAreFilled(event) {
    var formIsValid = true;
    this.element.querySelectorAll('input[type=text]').forEach(function(textInput) {
      if(!textInput.value.trim().length) {
        formIsValid = false;
        textInput.classList.add('error');
      } else {
        textInput.classList.remove('error');
      }
    })
    return formIsValid;
  }

  validateAccrualsAndSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    if(this.informIfStepIsLocked(event)) { return; }
    if(this.allRequiredInputsAreFilled(event)) {
      let submitToAltPathController = this.application.getControllerForElementAndIdentifier(this.element, 'submit-to-alt-path');
      submitToAltPathController.submitToAltPath(event);
    }
  }

  informIfStepIsLocked(event) {
    const activeAccordion = this.findActiveAccordionElement();
    var lockedMsg = "";
    if(!activeAccordion.classList.contains('current')) {
      if(activeAccordion.classList.contains('locked')) {
        lockedMsg = 'Du behöver låsa upp steget innan du kan göra ändringar.'
      } else {
        lockedMsg = 'Du är inte på det här steget och kan därför inte göra ändringar.'
      }
      new Fakturan.Alert({content: lockedMsg}).show()
      return true;
    }
    return false;
  }

  submitForm() {
    this.element.getElementById('hidden_submit').click();
  }
}